var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 109,
    viewBox: "0 0 93 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3123 106.122H13.7663C8.78247 106.122 4.74243 102.075 4.74243 97.0816V6.50505C4.74243 5.0506 5.91927 3.87134 7.37129 3.87134H86.7078C88.1596 3.87134 89.3367 5.05034 89.3367 6.50505V97.0816C89.3364 102.075 85.2961 106.122 80.3123 106.122Z",
    fill: "#D4AF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3355 6.50578V97.0811C89.3355 102.074 85.2952 106.122 80.3108 106.122H71.1443C76.1258 106.122 80.1661 102.075 80.1661 97.0811V6.50578C80.1661 5.04929 78.991 3.87207 77.5372 3.87207H86.7063C88.1576 3.87207 89.3355 5.04929 89.3355 6.50578Z",
    fill: "#B8860B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3352 6.5057V21.129H4.74243V6.5057C4.74243 5.04972 5.91875 3.87378 7.37206 3.87378H86.7055C88.1588 3.87378 89.3352 5.04946 89.3352 6.5057Z",
    fill: "#2C3E50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8017 12.4993V21.1272H4.74146L15.8017 12.4993Z",
    fill: "#2C3E50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2755 12.4993V21.1272H89.3357L78.2755 12.4993Z",
    fill: "#2C3E50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7068 3.87158L78.2755 12.4996L89.3357 21.1275V6.50504C89.3357 5.05059 88.1586 3.87158 86.7068 3.87158Z",
    fill: "#34495E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37032 3.87231L15.8017 12.5003L4.74146 21.128V6.50577C4.74146 5.05132 5.91855 3.87231 7.37032 3.87231Z",
    fill: "#34495E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0386 82.9143C35.3509 82.9143 25.8423 73.3881 25.8423 61.6788V46.0203C25.8423 44.9295 26.725 44.0452 27.8138 44.0452C28.9026 44.0452 29.7853 44.9295 29.7853 46.0203V61.6788C29.7853 71.2099 37.5251 78.964 47.0386 78.964C56.552 78.964 64.2918 71.2099 64.2918 61.6788V45.9236C64.2918 44.8329 65.1746 43.9485 66.2634 43.9485C67.3521 43.9485 68.2349 44.8329 68.2349 45.9236V61.6788C68.2349 73.3881 58.7263 82.9143 47.0386 82.9143Z",
    fill: "#B8860B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0386 76.3016C35.3667 76.3016 25.8708 66.7882 25.8708 55.0948V39.4363C25.8708 38.3611 26.7408 37.4898 27.8138 37.4898C28.887 37.4898 29.7567 38.3613 29.7567 39.4363V55.0948C29.7567 64.6417 37.5093 72.4083 47.0383 72.4083C56.5673 72.4083 64.3199 64.6414 64.3199 55.0948V39.3393C64.3199 38.2642 65.1899 37.3928 66.2628 37.3928C67.336 37.3928 68.206 38.2644 68.206 39.3393V55.0948C68.2063 66.7885 58.7104 76.3016 47.0386 76.3016Z",
    fill: "#F6F9FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2634 39.4367C68.6869 39.4367 70.6516 37.4684 70.6516 35.0404C70.6516 32.6124 68.6869 30.644 66.2634 30.644C63.8398 30.644 61.8751 32.6124 61.8751 35.0404C61.8751 37.4684 63.8398 39.4367 66.2634 39.4367Z",
    fill: "#D4AF37"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8138 39.4367C30.2373 39.4367 32.202 37.4684 32.202 35.0404C32.202 32.6124 30.2373 30.644 27.8138 30.644C25.3902 30.644 23.4255 32.6124 23.4255 35.0404C23.4255 37.4684 25.3902 39.4367 27.8138 39.4367Z",
    fill: "#D4AF37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.f076680cc07a6920910e8e14f9e809f9.svg";
export { ForwardRef as ReactComponent };